import { AuthRoute } from '../enums/auth-route';
import { BusinessModule } from '../enums/business/business-module';
import { BusinessType } from '../enums/business/business-type';

export class AuthHelper {
  public static getContinueUrl(url: string | null): string | null {
    if (!url || url[0] !== '/') return null;

    const path = url.split('?')[0];
    const isAuthRoute = Object.values(AuthRoute).some((route) =>
      path.startsWith(route),
    );
    if (isAuthRoute) return null;

    return url;
  }

  public static getBusinessModules(type: BusinessType): BusinessModule[] {
    const isNotSender = type !== BusinessType.SENDER;

    const modules: Record<BusinessModule, boolean> = {
      [BusinessModule.DELEGATIONS]: isNotSender,
      [BusinessModule.DRIVERS]: isNotSender,
      [BusinessModule.FLEET]: isNotSender,
      [BusinessModule.BASES]: isNotSender,
      [BusinessModule.FUEL_POLICY]: isNotSender,
      [BusinessModule.ROUTE_COSTS_AND_PREFERENCES]: isNotSender,
      [BusinessModule.ENGINE_CONFIG]: isNotSender,
      [BusinessModule.INTEGRATIONS]: isNotSender,
    };

    return Object.values(BusinessModule).filter((module) => modules[module]);
  }
}
